<template>
  <div class="row">
    <div class="col-md-3 col-sm-3">
      <div class="list-group">
        <template v-for="(principle, index) in principles">
          <a :key="principle.principle" :class="{'active': activeTab === index+1}" class="nav-link list-group-item" data-toggle="pill" role="tab" :href="'#'+index+1" @click="tab(index+1)">
            <template v-if="auditStatus === 'InProgress'">
              <i class="fa fa-th-list m-r-10" />
            </template>
            {{ index+1 }}
            <span v-if="principle" :title="principle.description" data-placement="right" data-toggle="tooltip">
              {{ principle.description | truncate(30, '...') }}
            </span>
          </a>
        </template>
      </div>
    </div>
    <div class="col-md-9 col-sm-9">
      <div v-for="(principle, index) in principles" :id="index+1" :key="principle.principle" :class="{'show': activeTab === index+1}" class="tab-pane active" role="tabpanel">
        <principle v-if="activeTab === index+1" :auditStatus="auditStatus" :auditId="auditId" :auditor="auditor" :certificationId="certificationId" :impactArea="impactArea.impact_area" :principle="principle" :principle-index="index+1" />
      </div>
    </div>
  </div>
</template>

<script>
import Principle from './Principle.vue';
export default {
  name: 'ImpactArea',
  components: { Principle },
  props: ['impactArea', 'auditId', 'auditStatus', 'auditor', 'certificationId'],
  data() {
    return {
      activeTab: 1,
      principles: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.getPrinciples();
    },
    async getPrinciples() {
      try {
        this.principles = (await this.$api.get(`audits/principles?impact_area=${this.impactArea.impact_area}`)).data;
      } catch (e) {
        console.error(e);
      }
    },
    tab(tabname) {
      this.activeTab = tabname;
    }
  }
}
</script>

<style scoped>
</style>
